import { API_BASE_URL_IMAGE } from "./API_CONSTANT";

export const buildCheckpointImages = (item: any) => {
    const imgs: Array<{ url: string; title?: string }> = [];
  
    if (item?.sealImage?.contentUrl) {
      imgs.push({
        url: `${API_BASE_URL_IMAGE}${item.sealImage.contentUrl}`,
        title: "Image plomb",
      });
    }
  
    if (Array.isArray(item?.images)) {
      item.images.forEach((img: any, idx: number) => {
        if (img?.contentUrl) {
          imgs.push({
            url: `${API_BASE_URL_IMAGE}${img.contentUrl}`,
            title: `Image ${idx + 1}`,
          });
        }
      });
    }

    if (Array.isArray(item?.additionalSealImages)) {
      item.additionalSealImages.forEach((img: any, idx: number) => {
        if (img?.contentUrl) {
          imgs.push({
            url: `${API_BASE_URL_IMAGE}${img.contentUrl}`,
            title: `Image plomb additionnel ${idx + 1}`,
          });
        }
      });
    }
  
    return imgs;
  };